import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

 const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Chart',
    },
  },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

 const data = {
  labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: [10,20,30,40,50,60,70],
      backgroundColor: 'black',
    },
    {
      label: 'Dataset 1',
      data: [10,20,30,40,50,60,70],
      backgroundColor: 'lightgray',
    },

  ],
};

export default function Chart() {
  return <Bar options={options} data={data} width={50}
  height={50}/>;
}
